import { render, staticRenderFns } from "./modalDownload.vue?vue&type=template&id=c1324fa8&"
import script from "./modalDownload.vue?vue&type=script&lang=ts&"
export * from "./modalDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports